module.exports = __webpack_public_path__ + "static/doggie@2x-0ec5c057766c549f66a661ebef2732f5.png";